import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Spinner from 'components/Spinner';
import { checkinAction } from 'actions/workflow';

const Checkin = ({
  dispatch,
  navigate,
  searchParams,
}) => {
  useEffect(() => {
    dispatch(checkinAction({
      key: searchParams.get('key'),
      success: (res) => {
        navigate(get(res, 'data.url') || '/');
      },
      fail: () => {
        navigate('/');
      }
    }));
  }, []);

  return (
    <div className="text-center mb-6">
      <Spinner size={12} color="blue-400" />
    </div>
  );
};

Checkin.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default Checkin;
